import React from 'react'
import Link from 'next/link'

const PostTags = ({ tags }) => (
  <div className=" text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm">
    {tags.map((tagItem) => (
      <Link key={tagItem} href={`/tags/${tagItem}`}>
        <div className="tag-link">{tagItem}</div>
      </Link>
    ))}
  </div>
)

export default PostTags